module.exports = __webpack_public_path__ + "resources/bootstrap/fonts/glyphicons-halflings-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bootstrap/fonts/glyphicons-halflings-regular.woff
// module id = 335
// module chunks = 0